@if (isLoading()) {
  <app-loading />
} @else {
  <div class="grid grid-cols-9 gap-2 mb-6">
    @for (chapterMetrics of chapterMetrics(); track chapterMetrics.chapterType; let i = $index) {
      <app-chapter-progress-ring
        [label]="
          i +
          1 +
          '. ' +
          (chapterTranslationsByType().get(chapterMetrics.chapterType) | translateDirectus)
        "
        [totalSteps]="chapterMetrics.totalSteps"
        [completedSteps]="chapterMetrics.completedSteps"
        [inProgressSteps]="chapterMetrics.inProgressSteps"
      />
    }
  </div>
}
